/* eslint-disable @typescript-eslint/ban-types */
import React, {useCallback, useEffect, useMemo, useState } from 'react';
import { CheckBox, CustomButtonGroup, CustomInput, SelectDropDown, useAppDispatch, useAppSelector, } from '../../../globalUtils/globalExports';
import { fetchAdvanceRuleEngineSetParameterParams, getReferenceDataReducer } from '../../../rmsReduxStore/reduxExports';
import '../../../rmsAssets/rmsIcons.css'
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Icon } from '../../../globalUtils/globalIcons';
import { parseDropDownValues } from '../../chargers/ChargerPanel/ChargerPanelSettingsDashboard';
import { cloneDeep, isEqual } from 'lodash';
import { checkValidDecimal, checkValidInteger, ExecutionPlan, SetParameterAction, SetParameters } from './ExecutionPlan';
import './SetParameterSidePopover.css';
import './FlowControlSidePopover.css';

interface SetParameterSidePopover {
    setParameters: null | SetParameters[];
    handleClose: () => void;
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    ifOrElse: String;
    parentNodeId: string;
    nodeId: string;
}

const SetParameterSidePopover = ({
    setParameters,handleClose,executionPlan,handleUpdateExecutionPlan,ifOrElse, parentNodeId,nodeId
} : SetParameterSidePopover) => {    

    const dispatch = useAppDispatch(); 
    const { advanceRuleEngineSetParameterParam } = useAppSelector(getReferenceDataReducer);
    const [popOverData,setPopOverData] = useState<SetParameters[]>([{
        parameterId: '',
        parameterName: '',
        parameterCondition: '',
        parameterConditionName: '',
        parameterValue: [],
        parameterOperator: '',
        connectorScope: null,
        connectorType: null,
        fieldType: '',
        dataType: '',
        unit: '',
        possibleValue: '',
        errorMessage: '',
        parameterType: null,
        hasOffset: false
    }])
    const [initialPopOverData,setInitialPopOverData] = useState<SetParameters[]>([{
        parameterId: '',
        parameterName: '',
        parameterCondition: '',
        parameterConditionName: '',
        parameterValue: [],
        parameterOperator: '',
        connectorScope: null,
        connectorType: null,
        fieldType: '',
        dataType:'',
        unit: '',
        possibleValue: '',
        errorMessage: '',
        parameterType: null,
        hasOffset: false
    }]);  

    useEffect(()=>{
        if(setParameters){
            setInitialPopOverData(setParameters)
            setPopOverData(setParameters);
        }
        dispatch(fetchAdvanceRuleEngineSetParameterParams());
    },[])

    const checkValidationsAndShowError = (subParameter, value): string | null => {
        const parsedValues = JSON.parse(subParameter?.possibleValue)
        if (subParameter?.dataType === 'Integer') {
          if(subParameter?.hasOffset) {
            if(!value || !checkValidInteger(value))return 'Enter a valid Integer value'; 
            return null;     
          }
          return value && !checkValidInteger(value) ? 'Enter a valid Integer value' :  subParameter?.parameterConditionName === 'Between' ? ((subParameter && subParameter?.parameterValue.length > 1 &&  subParameter?.parameterValue[0] >  subParameter?.parameterValue[1]) ? 'The second value must be greater than the first value' : null) : parsedValues && !(parseInt(value) >= parsedValues['min'] && parseInt(value) <= parsedValues['max']) ? `Please enter a value between ${parsedValues['min']} and ${parsedValues['max']}.`
           : null
        } else if (subParameter?.dataType === 'Double') {
            if(subParameter?.hasOffset) {
                if(!value || !checkValidDecimal(value))return 'Enter a valid Double value'; 
                return null    
            }
          return value && !checkValidDecimal(value) ? 'Enter a valid Double value' : subParameter?.parameterConditionName === 'Between' ? ((subParameter && subParameter?.parameterValue.length > 1 &&  subParameter?.parameterValue[0] >  subParameter?.parameterValue[1]) ? 'The second value must be greater than the first value' : null) : parsedValues && !(parseFloat(value) >= parsedValues['min'] && parseFloat(value) <= parsedValues['max']) ? `Please enter a value between ${parsedValues['min']} and ${parsedValues['max']}.` : null
        } 
        return null
    }
    
    const disableButton = useCallback(() => {
            if(isEqual(initialPopOverData,popOverData)){
                return true
            }
            else{
                let result = true;
                popOverData.forEach((item,) => {
                if(item?.parameterId.length > 0 && item.parameterCondition.length >0 && item.parameterValue.length > 0){
                    result = result && item.parameterId.length > 0  && item.parameterCondition.length > 0 && item.parameterValue && item.parameterValue.length > 0
                    if(item?.errorMessage && item?.errorMessage.length > 0)
                        result = result && !(item?.errorMessage.length > 0)
                    } else {
                        result = false;
                    }
                });
            return !result; 
            }
    }, [popOverData]);

    const checkMinMax =(val) =>{
        if (!val || typeof val !== 'string') {
            return false;
        }
        try {
            const options = parseDropDownValues(val);
            return (options.length >0 && (options[0].id === 'min' || options[1].id === 'max')) ? true : false;
        } catch (error) {
            return false;
        }
    }

    const btnsList = useMemo(() => {
        return [
          {
            buttonText: 'Save',
            buttonId: 'add',
            btnClassName:  disableButton() ? 'primary__btn disabled' : 'primary__btn',
            handleClick: (): void => {
                
                const data = cloneDeep(popOverData);
                const formattedData : SetParameterAction = {
                    type: 'Set Parameter',
                    nodeId,
                    parameters: data, 
                }
                const executionData = cloneDeep(executionPlan);
                const actionIdx = executionData?.actions?.findIndex((executionDataItem) => executionDataItem.flowType === ifOrElse && executionDataItem?.parentNodeId === parentNodeId);
                const actionItemIndex = executionData?.actions?.[actionIdx]?.list?.findIndex(item => item?.type === 'Set Parameter');
                if(actionItemIndex === -1){
                    executionData?.actions?.[actionIdx]?.list?.push(formattedData)
                }else{
                    executionData.actions[actionIdx].list[actionItemIndex] = formattedData
                }

                handleUpdateExecutionPlan(executionData);
                handleClose();
            },
            isDisabled: disableButton(),
            buttonVariant: 'filled',
          },
          {
            buttonText: 'Cancel',
            buttonId: 'cancel',
            btnClassName: 'secondary__btn',
            handleClick: (): void => {
                handleClose()
            },
            isDisabled: false,
            buttonVariant: 'outlined',
          },
        ];
      }, [popOverData]);

    const handleClick = () => {
        setPopOverData([...popOverData, {
            parameterCondition: '', 
            parameterOperator: 'AND', 
            parameterValue: [], 
            fieldType: '', 
            unit: '', 
            possibleValue: '',
            parameterId: '',
            errorMessage: '',
            parameterName: '',
            parameterConditionName: '',
            parameterType: null,
            connectorScope: null,
            connectorType: null,
        }])
    };

    const handleDeleteIconClick = (idx: number)=>{
        const data = popOverData.filter((item, index)=>{
            return (index!==idx)
        })
        setPopOverData(data);
    }

    const renderDropDownOptions = (val) => {
        if (!val || typeof val !== 'string') {
            return [];
        }
        try {
            const options = parseDropDownValues(val);
            return options;
        } catch (error) {
            return [];
        }
    };

    const offsetOperators = [
        {id:'+',name:'+ (plus)', label: '+ (plus)',value: '+'},
        {id:'-',name:'- (minus)', label: '- (minus)',value: '-'},
    ]

    return(
        <>
        <div className='advance__rule__engine__flow__controls__side__popover__wrapper'>
            <div className='advance__rule__engine__flow__control__side__popover__column__label'>
                <div className='advance__rule__engine__flow__control__side__popover__label advance__rule__engine__flow__control__side__popover__parameter__label'>
                    Parameter*
                </div>
                <div className='advance__rule__engine__flow__control__side__popover__label advance__rule__engine__flow__control__side__popover__operator__label'>Operator*
                </div>
                <div className='advance__rule__engine__flow__control__side__popover__label advance__rule__engine__flow__control__side__popover__value__label'>
                Value*
                </div>
            </div>
            <hr className="custom-hr" />
            <div className='advance__rule__engine__flow__control__side__popover__parameters'>
            {
                popOverData && popOverData?.map((item, idx)=>{
                return <div key = {idx}>
                        {item.parameterOperator && 
                        <div className='advance__rule__engine__flow__control__side__popover__logical__operator'>
                            <CustomInput 
                                    inputValue={'AND'} 
                                    inputFieldId={'advance__rule__engine__rule__engine__set__parameter__logical__operator'} 
                                    isRequired={true}   
                                    isDisabled={true}
                                />
                            </div>}
                        <div className='advance__rule__engine__flow__control__side__popover__dropdown'>

                            <div className='advance__rule__engine__flow__control__side__popover__parameter__label'>
                            <SelectDropDown 
                            dropDownClassName={'advance__rule__engine__parameter__select'}
                            selectDropDownId={'advance__rule__engine__paramter-name'}
                            selectValue={{id: item.parameterName,label: item.parameterName}}
                            renderToBody={true}
                            handleSelectOptionChange={(val) : void =>{
                            const data = cloneDeep(popOverData);
                            data[idx]['parameterId'] = val?.id;
                            data[idx]['parameterName'] = val?.label;
                            data[idx]['parameterCondition'] = (val?.possibleValue && val?.possibleValue!== null && !checkMinMax(val?.possibleValue) ) ? 'is': 'equalsTo' ;
                            data[idx]['parameterConditionName'] = (val?.possibleValue && val?.possibleValue!== null && !checkMinMax(val?.possibleValue) ) ? 'is': 'Equals to' ;
                            data[idx]['parameterValue'] = [];
                            data[idx]['fieldType'] = val?.fieldType;
                            data[idx]['dataType'] =  val?.dataType;
                            data[idx]['unit'] = val?.unit;
                            data[idx]['possibleValue'] = val?.possibleValue;
                            data[idx]['connectorScope'] = val?.parameterType === 'ConnectorParameter' ? 'any' : null,
                            data[idx]['connectorType'] = val?.acOrDc,
                            data[idx]['errorMessage'] = '';
                            data[idx]['parameterType'] = val?.parameterType;
                            data[idx]['hasOffset'] = false;
                            setPopOverData(data);
                            }} 
                            selectOptions={advanceRuleEngineSetParameterParam ?? []}        
                            />
                            </div>
                            <div className='advance__rule__engine__flow__control__side__popover__operator__label'>
                            {
                                item?.hasOffset ? 
                                <SelectDropDown
                                    selectDropDownId='advance_rule_engine-offset-operator-selection-dropdown'
                                    selectValue={offsetOperators?.find(operator=> operator?.id === item?.parameterCondition)}
                                    handleSelectOptionChange={(value) => {
                                        const data = cloneDeep(popOverData);
                                        data[idx]['parameterConditionName'] = value?.label;
                                        data[idx]['parameterCondition'] = value?.id;
                                        setPopOverData(data);
                                    }}
                                    selectOptions={offsetOperators}
                                    renderToBody={true}
                                    isDisabled={!item?.parameterId}
                                />
                                :
                                <CustomInput
                                inputValue={item.parameterConditionName??''}
                                inputFieldId={'advance__rule__engine__rule__engine__set__parameter__operator__value'} 
                                isRequired={true}
                                isDisabled={true}
                                />
                            }
                            </div>

                            <div className='advance__rule__engine__flow__control__side__popover__value__label'>
                            {item?.fieldType === 'DropDownMultiple' ? (
                                <div style={{width: '180px'}}>
                                    <SelectDropDown 
                                        selectDropDownId={'advance__rule__engine__rule__engine__set__parameter__dropdown__value'} 
                                        handleSelectOptionChange={(val)=>{
                                            const data = cloneDeep(popOverData);
                                            data[idx]['parameterValue'] = val?.map((item)=> item?.label)
                                            setPopOverData(data);
                                        } } 
                                        selectOptions={renderDropDownOptions(popOverData[idx]?.possibleValue) ?? []} 
                                        selectValue={renderDropDownOptions(popOverData[idx]?.possibleValue)?.filter((item)=> popOverData[idx]['parameterValue']?.includes(item?.label))}
                                        isDisabled={popOverData[idx]['parameterCondition'].length > 0 ? false : true}
                                        isMultiSelect={true}
                                />
                                </div>
                            ) : item?.fieldType === 'DropDownSingle' ?
                                <div style={{width: '180px'}}>
                                    <SelectDropDown 
                                        selectDropDownId={`advance__rule__engine__rule__engine__set__parameter__drop__down__value__${idx}`}
                                        selectOptions={renderDropDownOptions(popOverData[idx]?.possibleValue) ?? []} 
                                        isDisabled={popOverData[idx]['parameterCondition'].length > 0 ? false : true}
                                        handleSelectOptionChange={(val)=>{
                                            const data = cloneDeep(popOverData);
                                            data[idx]['parameterValue'][0] = val?.label
                                            setPopOverData(data);
                                        }} 
                                        isMultiSelect={false}
                                        selectValue={{ id: item.parameterValue[0], label : item.parameterValue[0]}}
                                />
                                </div>
                            : 
                            (
                                <>
                                    <CustomInput 
                                        inputValue={item.parameterValue.length > 0 ? item.parameterValue[0] : ''} 
                                        inputFieldId={'advance__rule__engine__rule__engine__set__parameter__parameter__value'} 
                                        isRequired={true}   
                                        isDisabled={popOverData[idx]['parameterCondition'].length > 0 ? false : true}
                                        handleInputChange={(e) => {
                                        const data = cloneDeep(popOverData);
                                        data[idx]['parameterValue'][0]= (e.target.value);
                                        const error = checkValidationsAndShowError(popOverData[idx],e.target.value);
                                        data[idx]['errorMessage'] = error!==null ? error : '';
                                        setPopOverData(data);
                                        }} 
                                        errorMessage={popOverData[idx]['errorMessage']}
                                    />
                                    {item?.fieldType === 'Input' && item?.unit && item?.unit !== 'NA' && (
                                        <div className='charger__status__toggle__wrap__content-row-value-wrap-unit'>
                                        {item.unit}
                                        </div>
                                    )}
                                </>
                            )}
                            </div>
                        {
                            idx > 0 && <Icon iconClassName='rms__delete__icon' onIconClick={() => handleDeleteIconClick(idx)}/>
                        }

                        </div>

                        <div className='advance__rule__engine__setting__param__checkboxes'>
                            {/* enable / disable offset toggle */}
                            {
                                (item?.fieldType && item?.dataType && item?.fieldType==='Input' && item?.dataType !== 'String') && <div className='advance__rule__engine__set__parameter__enable__disable__offset__container'>
                                    <div className='advance__rule__engine__set__parameter__enable__disable__offset-checkbox'
                                    onClick={()=>{
                                        if(!item?.parameterId)return;
                                        const hasOffset = !item?.hasOffset;
                                        const data = cloneDeep(popOverData);
                                        data[idx].hasOffset = hasOffset;
                                        if(!hasOffset){
                                            data[idx]['parameterCondition'] = 'equalsTo' ;
                                            data[idx]['parameterConditionName'] = 'Equals to' ;
                                        }
                                        setPopOverData(data);
                                    }}
                                    >
                                        <CheckBox 
                                            checked={item?.hasOffset ?? false} 
                                            
                                        />
                                    </div>
                                    <div className='advance__rule__engine__set__parameter__enable__disable__offset-label'>Use Offset</div>
                                </div>
                            }
                            {
                                (item?.parameterType === 'ConnectorParameter') && <div className='advance__rule__engine__set__parameter__enable__disable__offset__container'>
                                    <div className='advance__rule__engine__set__parameter__enable__disable__offset-checkbox'
                                    onClick={()=>{
                                    if(item?.parameterType !== 'ConnectorParameter')return;
                                    const data = cloneDeep(popOverData);
                                    data[idx]['connectorScope'] = data[idx]['connectorScope'] === 'any' || data[idx]['connectorScope'] == null ? 'all' : 'any';
                                    setPopOverData(data);
                                    }}
                                    >
                                        <CheckBox 
                                            checked={item?.connectorScope === 'all'}  
                                            isDisabled = {item?.parameterType !== 'ConnectorParameter'} 
                                        />
                                    </div>
                                    <div className='advance__rule__engine__set__parameter__enable__disable__offset-label'>Execute for all connectors</div>
                                </div>
                            }
                        </div>
                    </div>
                })
            }
            </div>
            <Button
                startIcon={<AddIcon />}
                sx={{ color: '#49c8d1', textTransform: 'none', fontSize: '1rem',marginTop:'12px' ,display: 'flex', justifyContent: 'flex-start', width:'180px'}}
                onClick={handleClick}
            >
                <div className='advance__rule__engine__flow__control__side__popover__add__condition'>  Add Condition </div>
            </Button>  

        </div>
        <div className='advance__rule__engine__side__popover-footer'>
          <CustomButtonGroup
            buttonsList={btnsList}
            buttonGroupClassName='button__group__footer' />
        </div>
        </>
    )
};

export default SetParameterSidePopover;